import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { CardAttachment, CardTitleValueHtml, CardValueHtml } from "@shared/models/card-stack"
import type { Permission } from "@shared/models/permissions"
import type { AiValueEditor } from "cc-frontend/lib/ai/ai-value-editor"
import type EmberStore from "cc-frontend/services/ember-store"
import type LessonEditor from "cc-frontend/services/lesson-editor"
import type { ModelsNeededForFirstEdit } from "cc-frontend/services/lesson-editor"

interface Args {
  cardStackId: string
  card: CardTitleValueHtml | CardValueHtml
  modelsNeededForFirstEdit: ModelsNeededForFirstEdit
  permissions: Array<Permission>
  registerCardEditor?: (cardId: string, prop: string, editor: AiValueEditor<unknown>) => void
}

export default class HtmlValue extends Component<Args> {
  // Services
  @service("ember-store") store!: EmberStore
  @service lessonEditor!: LessonEditor

  // Actions
  @action
  updateSection(id: string, prop: string, value: string | null) {
    this.lessonEditor.editCard(
      this.args.modelsNeededForFirstEdit,
      this.args.cardStackId,
      id,
      prop,
      value
    )
  }

  @action
  finishedEditing(
    id: string,
    prop: string,
    value: any,
    originalValue: string | null,
    wordCountChange: number
  ) {
    this.lessonEditor.finishEditingCard(
      this.args.modelsNeededForFirstEdit,
      this.args.cardStackId,
      id,
      prop,
      value,
      originalValue,
      wordCountChange
    )
  }

  @action addAttachments(files: Omit<CardAttachment, "id">[]) {
    this.lessonEditor.addAttachments(
      this.args.modelsNeededForFirstEdit,
      files,
      this.args.cardStackId,
      this.args.card.id,
      this.args.card.attributes.attachments,
      "drag"
    )
  }
}
